

import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  GoogleMap,
  Marker,
  LoadScript,
} from "@react-google-maps/api";


import { QRCodeCanvas } from "qrcode.react";

/* =========================
    MAP STYLE
========================= */

const mapContainerStyle = {
  width: "100%",
  height: "500px",
  borderRadius: "10px",
};



const Department = () => {

  /* =========================
      STATES
  ========================= */

  const [depName, setDepName] = useState("");

  const [latitude, setLatitude] = useState("");

  const [longitude, setLongitude] = useState("");

  const [departments, setDepartments] = useState([]);

  const [editId, setEditId] = useState(null);

  const [search, setSearch] = useState("");



  const [position, setPosition] = useState({
    lat: 17.3850,
    lng: 78.4867,
  });



  const [mapRef, setMapRef] = useState(null);



  /* =========================
      GOOGLE MAP API KEY
  ========================= */

  const GOOGLE_MAP_KEY = "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA";

  const [showForm, setShowForm] = useState(false);


  /* =========================
      GET CURRENT LOCATION
  ========================= */

  const getCurrentLocation = () => {

    navigator.geolocation.getCurrentPosition(

      (pos) => {

        const lat = pos.coords.latitude;

        const lng = pos.coords.longitude;

        setLatitude(lat);

        setLongitude(lng);

        setPosition({
          lat,
          lng,
        });

        if (mapRef) {

          mapRef.panTo({
            lat,
            lng,
          });

          mapRef.setZoom(16);
        }
      },

      (err) => {

        console.log(err);

        alert("Location Permission Denied");

      }

    );
  };




  /* =========================
      FETCH DEPARTMENTS
  ========================= */

  const fetchDepartments = async () => {

    try {

      const res = await axios.get(
        "https://gpsapi.emedha.in/web/api/department"
      );

      setDepartments(res.data);

    } catch (error) {

      console.log(error);

    }
  };



  useEffect(() => {

    fetchDepartments();

    getCurrentLocation();

  }, []);




  /* =========================
      SEARCH LOCATION
  ========================= */

  const handleSearch = async () => {

    if (!search) {

      alert("Please Enter Location");

      return;
    }

    try {

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${search}&key=${GOOGLE_MAP_KEY}`
      );

      const data = await response.json();

      if (data.results.length > 0) {

        const location =
          data.results[0].geometry.location;

        const lat = location.lat;

        const lng = location.lng;

        setLatitude(lat);

        setLongitude(lng);

        setPosition({
          lat,
          lng,
        });

        if (mapRef) {

          mapRef.panTo({
            lat,
            lng,
          });

          mapRef.setZoom(16);
        }

      } else {

        alert("Location Not Found");
      }

    } catch (error) {

      console.log(error);

    }
  };




  /* =========================
      MAP CLICK
  ========================= */

  const handleMapClick = (event) => {

    const lat = event.latLng.lat();

    const lng = event.latLng.lng();

    setLatitude(lat);

    setLongitude(lng);

    setPosition({
      lat,
      lng,
    });
  };





  const [radius, setRadius] = useState("");

  const handleSubmit = async () => {

    if (!depName) {

      alert("Please Enter Department Name");

      return;
    }

    const payload = {

      dep_name: depName,

      latitude: latitude,

      longitude: longitude,
      radius: Number(radius),
    };

    try {

      /* =========================
          UPDATE
      ========================= */

      if (editId) {

        await axios.put(
          `https://gpsapi.emedha.in/web/api/department/${editId}`,
          payload
        );

        alert("Department Updated Successfully");
        setShowForm(false);
      }

      /* =========================
          CREATE
      ========================= */

      else {

        await axios.post(
          "https://gpsapi.emedha.in/web/api/department",
          payload
        );

        alert("Department Added Successfully");
        setShowForm(false);
      }



      /* =========================
          CLEAR FORM
      ========================= */

      setDepName("");

      setLatitude("");

      setLongitude("");
      setRadius("");

      setEditId(null);



      /* =========================
          GET UPDATED DATA
      ========================= */

      const updatedData = await axios.get(
        "https://gpsapi.emedha.in/web/api/department"
      );

      setDepartments(updatedData.data);

    } catch (error) {

      console.log(error);

    }
  };

  /* =========================
      DELETE
  ========================= */

  const handleDelete = async (id) => {

    try {

      await axios.delete(
        `https://gpsapi.emedha.in/web/api/department/${id}`
      );

      alert("Deleted Successfully");

      fetchDepartments();

    } catch (error) {

      console.log(error);

    }
  };




  const handleEdit = (item) => {

    setShowForm(true);


    setEditId(item.id);

    setDepName(item.name);

    setLatitude(item.latitude);

    setLongitude(item.longitude);
    setRadius(item.radius);

    setPosition({
      lat: Number(item.latitude),
      lng: Number(item.longitude),
    });

    if (mapRef) {

      mapRef.panTo({
        lat: Number(item.latitude),
        lng: Number(item.longitude),
      });

      mapRef.setZoom(16);
    }
  };
  const downloadQRCode = (item) => {

    const canvas = document.getElementById(
      `qr-${item.id}`
    );

    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");

    downloadLink.href = pngUrl;

    downloadLink.download =
      `${item.name}_QR.png`;

    document.body.appendChild(downloadLink);

    downloadLink.click();

    document.body.removeChild(downloadLink);
  };


  return (

    <div
      style={{
        padding: "20px",
        backgroundColor: "#f4f6f9",
        minHeight: "100vh",
        fontFamily: "Arial",
      }}
    >

      <div>  <button
        onClick={() => setShowForm(!showForm)}
        style={{
          backgroundColor: showForm
            ? "red"
            : "#007bff",
          color: "#fff",
          border: "none",
          padding: "12px 20px",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "15px",
        }}
      >
        {showForm
          ? "Close Form"
          : "Add Department"}
      </button>
      </div>

      {/* MAIN CARD */}
      {showForm && (
        <div
          style={{
            maxWidth: "1000px",
            margin: "auto",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          }}
        >

          {/* TITLE */}

          <h2
            style={{
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            Department Screen
          </h2>



          {/* DEPARTMENT INPUT */}

          <input
            type="text"
            placeholder="Enter Department Name"
            value={depName}
            onChange={(e) => setDepName(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              marginBottom: "15px",
              outline: "none",
            }}
          />



          {/* SEARCH BAR */}

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "15px",
            }}
          >

            <input
              type="text"
              placeholder="Search Location..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                flex: 1,
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                outline: "none",
              }}
            />



            <button
              onClick={handleSearch}
              style={{
                padding: "12px 20px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Search
            </button>

          </div>



          {/* CURRENT LOCATION ICON BUTTON */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
            }}
          >

            <button
              onClick={getCurrentLocation}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#28a745",
                color: "#fff",
                fontSize: "22px",
                cursor: "pointer",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
              }}
              title="Get Current Location"
            >
              📍
            </button>

          </div>



       

          <input
            type="text"
            placeholder="Enter Latitude"
            value={latitude}
            onChange={(e) =>
              setLatitude(e.target.value)
            }
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              marginBottom: "15px",
              outline: "none",
            }}
          />

       

          <input
            type="text"
            placeholder="Enter Longitude"
            value={longitude}
            onChange={(e) =>
              setLongitude(e.target.value)
            }
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              marginBottom: "15px",
              outline: "none",
            }}
          />

          <input
            type="number"
            placeholder="Enter Radius"
            value={radius}
            onChange={(e) =>
              setRadius(e.target.value)
            }
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              marginBottom: "15px",
              outline: "none",
            }}
          />
          {/* GOOGLE MAP */}

          <div
            style={{
              position: "relative",
            }}
          >

            <LoadScript googleMapsApiKey={GOOGLE_MAP_KEY}>

              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={position}
                zoom={15}
                onClick={handleMapClick}
                onLoad={(map) => setMapRef(map)}
                options={{
                  streetViewControl: false,
                  mapTypeControl: true,
                  fullscreenControl: true,
                }}
              >

                {/* MARKER */}

                <Marker
                  position={position}
                />

              </GoogleMap>

            </LoadScript>

          </div>



          {/* SAVE BUTTON */}

          <button
            onClick={handleSubmit}
            style={{
              width: "100%",
              padding: "14px",
              backgroundColor: editId ? "orange" : "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              marginTop: "20px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            {editId
              ? "Update Department"
              : "Add Department"}
          </button>

        </div>


      )}

      {/* TABLE */}

      <div
        style={{
          marginTop: "40px",
          overflowX: "auto",
        }}
      >

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            backgroundColor: "#fff",
          }}
        >

          <thead>

            <tr
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
              }}
            >

              {/* <th style={tableHead}>ID</th>

              <th style={tableHead}>Department Name</th>

              <th style={tableHead}>Coordinates</th> */}

              <th style={tableHead}>ID</th>

              {/* <th style={tableHead}>
                Department ID
              </th> */}

              <th style={tableHead}>
                Department Name
              </th>

              <th style={tableHead}>
                Latitude
              </th>

              <th style={tableHead}>
                Longitude
              </th>
              <th style={tableHead}>
                Radius
              </th>
              {/* <th style={tableHead}>Created Time</th> */}

              <th style={tableHead}>Actions</th>

              <th style={tableHead}>QR Code</th>

            </tr>

          </thead>

          <tbody>

            {departments.map((item) => (

              <tr key={item.id}>

                <td style={tableCell}>
                  {item.id}
                </td>

              
                <td style={tableCell}>
                  {item.name}
                </td>

                <td style={tableCell}>
                  {item.latitude}
                </td>

                <td style={tableCell}>
                  {item.longitude}
                </td>

                <td style={tableCell}>
                  {item.radius}
                </td>
             
                <td style={tableCell}>

                  <button
                    onClick={() => handleEdit(item)}
                    style={{
                      backgroundColor: "orange",
                      color: "#fff",
                      border: "none",
                      padding: "8px 15px",
                      borderRadius: "5px",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </button>



                  <button
                    onClick={() => handleDelete(item.id)}
                    style={{
                      backgroundColor: "red",
                      color: "#fff",
                      border: "none",
                      padding: "8px 15px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>

                </td>
                <td style={tableCell}>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >

                

                    <QRCodeCanvas
                      id={`qr-${item.id}`}
                      value={JSON.stringify({
                        id: item.id,
                        name: item.name,
                        latitude: item.latitude,
                        longitude: item.longitude,
                         radius: item.radius,
                      })}
                      size={120}
                      level="H"
                      includeMargin={true}
                    />



                    <button
                      onClick={() => downloadQRCode(item)}
                      style={{
                        backgroundColor: "#28a745",
                        color: "#fff",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Download QR
                    </button>

                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};



const tableHead = {
  border: "1px solid #ddd",
  padding: "12px",
};

const tableCell = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "center",
};



export default Department;


// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
// import { QRCodeCanvas } from "qrcode.react";
// import Swal from "sweetalert2";
// import { colors } from "../utils/theme";
// import { 
//   MapPin, 
//   Plus, 
//   X, 
//   Search as SearchIcon, 
//   Edit3, 
//   Trash2, 
//   Download, 
//   Target 
// } from "lucide-react";


// /* =========================
//     MAP STYLE
// ========================= */
// const mapContainerStyle = {
//   width: "100%",
//   height: "400px",
//   borderRadius: "16px",
//   border: `1px solid #eee`,
// };

// const Department = () => {
//   const [depName, setDepName] = useState("");
//   const [latitude, setLatitude] = useState("");
//   const [longitude, setLongitude] = useState("");
//   const [radius, setRadius] = useState("");
//   const [departments, setDepartments] = useState([]);
//   const [editId, setEditId] = useState(null);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [position, setPosition] = useState({ lat: 17.3850, lng: 78.4867 });
//   const [mapRef, setMapRef] = useState(null);

//   const GOOGLE_MAP_KEY = "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA";

//   const fetchDepartments = async () => {
//     try {
//       const res = await axios.get("https://gpsapi.emedha.in/web/api/department");
//       setDepartments(res.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     fetchDepartments();
//     getCurrentLocation();
//   }, []);

//   const getCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       showToast("Geolocation not supported", "error");
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         const lat = pos.coords.latitude;
//         const lng = pos.coords.longitude;
//         setLatitude(lat);
//         setLongitude(lng);
//         const newPos = { lat, lng };
//         setPosition(newPos);
//         mapRef?.panTo(newPos);
//       },
//       (err) => {
//         showToast("Location Permission Denied. Please enable it in browser settings.", "warning");
//       }
//     );
//   };

//   const showToast = (title, icon) => {
//     Swal.fire({
//       title,
//       icon,
//       toast: true,
//       position: 'top-end',
//       showConfirmButton: false,
//       timer: 3000,
//       timerProgressBar: true,
//       customClass: { popup: 'lux-toast' }
//     });
//   };

//  const { isLoaded, loadError } = useJsApiLoader({
//     id: 'google-map-script',
//     googleMapsApiKey: GOOGLE_MAP_KEY
//   });

//   const onMapLoad = useCallback((map) => {
//     setMapRef(map);
//   }, []);

//   const onUnmount = useCallback((map) => {
//     setMapRef(null);
//   }, []);

//   // 3. Updated Search to prevent map "freezing"
//   const handleSearch = async () => {
//     if (!search) return showToast("Enter a location", "info");
//     try {
//       const response = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(search)}&key=${GOOGLE_MAP_KEY}`
//       );
//       const data = await response.json();
//       if (data.results.length > 0) {
//         const { lat, lng } = data.results[0].geometry.location;
//         setLatitude(lat);
//         setLongitude(lng);
//         setPosition({ lat, lng });
        
//         // Ensure map exists before panto
//         if (mapRef) {
//             mapRef.panTo({ lat, lng });
//             mapRef.setZoom(16);
//         }
//       } else {
//         showToast("Location not found", "error");
//       }
//     } catch (error) {
//       console.log("Geocoding Error:", error);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!depName || !latitude || !longitude || !radius) {
//       return showToast("Please fill all fields", "warning");
//     }

//     const payload = { 
//       dep_name: depName, 
//       latitude, 
//       longitude, 
//       radius: Number(radius) 
//     };

//     try {
//       if (editId) {
//         await axios.put(`https://gpsapi.emedha.in/web/api/department/${editId}`, payload);
//         showToast("Updated successfully", "success");
//       } else {
//         await axios.post("https://gpsapi.emedha.in/web/api/department", payload);
//         showToast("Added successfully", "success");
//       }
//       resetForm();
//       fetchDepartments();
//     } catch (error) {
//       showToast("Server error", "error");
//     }
//   };

//   const resetForm = () => {
//     setDepName(""); setLatitude(""); setLongitude(""); setRadius("");
//     setEditId(null); setShowForm(false);
//   };

//   const handleDelete = (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This department will be permanently removed.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: colors.primary,
//       cancelButtonColor: "#aaa",
//       confirmButtonText: "Yes, delete it!",
//       buttonsStyling: true,
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios.delete(`https://gpsapi.emedha.in/web/api/department/${id}`);
//         showToast("Deleted", "success");
//         fetchDepartments();
//       }
//     });
//   };

//   const handleEdit = (item) => {
//     setEditId(item.id);
//     setDepName(item.name);
//     setLatitude(item.latitude);
//     setLongitude(item.longitude);
//     setRadius(item.radius);
//     setPosition({ lat: Number(item.latitude), lng: Number(item.longitude) });
//     setShowForm(true);
//     setTimeout(() => mapRef?.panTo({ lat: Number(item.latitude), lng: Number(item.longitude) }), 100);
//   };

//   const downloadQRCode = (item) => {
//     const canvas = document.getElementById(`qr-${item.id}`);
//     if (!canvas) return;
//     const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
//     const downloadLink = document.createElement("a");
//     downloadLink.href = pngUrl;
//     downloadLink.download = `${item.name}_QR.png`;
//     downloadLink.click();
//   };

//   return (
//     <div style={{ padding: "30px", backgroundColor: colors.background, minHeight: "100vh" }}>
      
//       {/* HEADER SECTION */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
//         <div>
//           <h1 style={{ fontSize: "28px", fontWeight: "800", color: colors.text, margin: 0 }}>Department Management</h1>
//           <p style={{ color: "#888", marginTop: "5px" }}>Configure geolocation zones and QR codes</p>
//         </div>
//         <button
//           onClick={() => setShowForm(!showForm)}
//           style={{
//             backgroundColor: showForm ? "#666" : colors.primary,
//             color: "#fff",
//             border: "none",
//             padding: "12px 24px",
//             borderRadius: "12px",
//             cursor: "pointer",
//             fontWeight: "700",
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             boxShadow: `0 8px 16px ${colors.primary}33`
//           }}
//         >
//           {showForm ? <X size={20} /> : <Plus size={20} />}
//           {showForm ? "Cancel" : "Add New Department"}
//         </button>
//       </div>

//       {/* FORM CARD */}
//       {showForm && (
//         <div className="animate-fade-in" style={styles.card}>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px" }}>
            
//             {/* Left Column: Inputs */}
//             <div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Department Name</label>
//                 <input 
//                   type="text" 
//                   placeholder="e.g. Accounts Main Office" 
//                   value={depName} 
//                   onChange={(e) => setDepName(e.target.value)} 
//                   style={styles.input} 
//                 />
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Search Area</label>
//                 <div style={{ display: "flex", gap: "10px" }}>
//                   <input 
//                     type="text" 
//                     placeholder="Search Google Maps..." 
//                     value={search} 
//                     onChange={(e) => setSearch(e.target.value)} 
//                     style={styles.input} 
//                   />
//                   <button onClick={handleSearch} style={styles.iconBtn}><SearchIcon size={18}/></button>
//                 </div>
//               </div>

//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Latitude</label>
//                   <input type="text" value={latitude} readOnly style={styles.inputDisabled} />
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Longitude</label>
//                   <input type="text" value={longitude} readOnly style={styles.inputDisabled} />
//                 </div>
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Geofence Radius (Meters)</label>
//                 <input 
//                   type="number" 
//                   placeholder="e.g. 50" 
//                   value={radius} 
//                   onChange={(e) => setRadius(e.target.value)} 
//                   style={styles.input} 
//                 />
//               </div>

//               <button onClick={handleSubmit} style={styles.submitBtn}>
//                 {editId ? "Update Department Settings" : "Save Department"}
//               </button>
//             </div>

//             {/* Right Column: Map */}
//          <div style={{ position: "relative", minHeight: '400px' }}>
//               {isLoaded ? (
//                 <GoogleMap
//                   mapContainerStyle={mapContainerStyle}
//                   center={position}
//                   zoom={15}
//                   onLoad={onMapLoad}
//                   onUnmount={onUnmount}
//                   onClick={(e) => {
//                     const lat = e.latLng.lat();
//                     const lng = e.latLng.lng();
//                     setLatitude(lat); setLongitude(lng);
//                     setPosition({ lat, lng });
//                   }}
//                   options={{
//                     disableDefaultUI: false,
//                     zoomControl: true,
//                   }}
//                 >
//                   <Marker position={position} />
//                 </GoogleMap>
//               ) : (
//                 <div style={styles.mapLoadingPlaceholder}>
//                    {loadError ? "Error loading maps" : "Initializing Maps..."}
//                 </div>
//               )}
              
//               <button onClick={getCurrentLocation} style={styles.floatingLocBtn}>
//                 <Target size={20} color="#fff" />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DATA TABLE */}
//       <div style={{ ...styles.card, marginTop: "30px", padding: 0, overflow: "hidden" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             <tr style={{ backgroundColor: "#fafafa", borderBottom: "1px solid #eee" }}>
//               <th style={styles.th}>ID</th>
//               <th style={styles.th}>Department Details</th>
//               <th style={styles.th}>Radius</th>
//               <th style={styles.th}>Actions</th>
//               <th style={styles.th}>Attendance QR</th>
//             </tr>
//           </thead>
//           <tbody>
//             {departments.map((item) => (
//               <tr key={item.id} style={{ borderBottom: "1px solid #f5f5f5" }}>
//                 <td style={styles.td}>#{item.id}</td>
//                 <td style={styles.td}>
//                   <div style={{ fontWeight: "700", color: colors.text }}>{item.name}</div>
//                   <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
//                     {item.latitude}, {item.longitude}
//                   </div>
//                 </td>
//                 <td style={styles.td}>
//                   <span style={styles.badge}>{item.radius}m</span>
//                 </td>
//                 <td style={styles.td}>
//                   <div style={{ display: "flex", gap: "8px" }}>
//                     <button onClick={() => handleEdit(item)} style={styles.editBtn}><Edit3 size={16}/></button>
//                     <button onClick={() => handleDelete(item.id)} style={styles.deleteBtn}><Trash2 size={16}/></button>
//                   </div>
//                 </td>
//                 <td style={styles.td}>
//                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
//                     <QRCodeCanvas
//                       id={`qr-${item.id}`}
//                       value={JSON.stringify({ id: item.id, name: item.name, lat: item.latitude, lng: item.longitude, radius: item.radius })}
//                       size={80}
//                       level="H"
//                       includeMargin={true}
//                     />
//                     <button onClick={() => downloadQRCode(item)} style={styles.downloadBtn}>
//                       <Download size={14} /> Download
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   card: {
//     backgroundColor: "#fff",
//     padding: "30px",
//     borderRadius: "20px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
//   },
//   inputGroup: { marginBottom: "20px" },
//   label: { display: "block", fontSize: "13px", fontWeight: "700", color: "#555", marginBottom: "8px", textTransform: "uppercase" },
//   input: {
//     width: "100%", padding: "14px", borderRadius: "12px", border: "1px solid #eee",
//     backgroundColor: "#fcfcfc", outline: "none", fontSize: "15px", transition: "0.3s"
//   },
//   inputDisabled: {
//     width: "100%", padding: "14px", borderRadius: "12px", border: "1px solid #eee",
//     backgroundColor: "#f5f5f5", color: "#888", cursor: "not-allowed"
//   },
//   iconBtn: {
//     padding: "12px", backgroundColor: colors.primary, color: "#fff", border: "none", borderRadius: "12px", cursor: "pointer"
//   },
//   submitBtn: {
//     width: "100%", padding: "16px", backgroundColor: colors.primary, color: "#fff", border: "none",
//     borderRadius: "14px", cursor: "pointer", fontWeight: "700", fontSize: "16px", marginTop: "10px",
//     boxShadow: `0 10px 20px ${colors.primary}33`
//   },
//   floatingLocBtn: {
//     position: "absolute", bottom: "20px", right: "20px", width: "45px", height: "45px",
//     borderRadius: "50%", border: "none", backgroundColor: "#28a745", cursor: "pointer",
//     display: "flex", alignItems: "center", justifyContent: "center", elevation: 5
//   },
//   th: { textAlign: "left", padding: "18px 25px", fontSize: "13px", color: "#999", textTransform: "uppercase", letterSpacing: "1px" },
//   td: { padding: "20px 25px", verticalAlign: "middle" },
//   badge: {
//     padding: "4px 10px", backgroundColor: "#f0fdf4", color: "#16a34a", borderRadius: "6px",
//     fontSize: "12px", fontWeight: "700"
//   },
//   editBtn: { padding: "10px", backgroundColor: "#fef9c3", color: "#ca8a04", border: "none", borderRadius: "10px", cursor: "pointer" },
//   deleteBtn: { padding: "10px", backgroundColor: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "10px", cursor: "pointer" },
//   downloadBtn: {
//     display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", fontWeight: "700",
//     color: colors.primary, background: "none", border: `1px solid ${colors.primary}33`,
//     padding: "6px 12px", borderRadius: "8px", cursor: "pointer"
//   }
// };

// export default Department;